/* unplugin-vue-components disabled */import { render } from "./TransactionInfo.vue?vue&type=template&id=8fa6b6e0&scoped=true"
import script from "./TransactionInfo.vue?vue&type=script&lang=js"
export * from "./TransactionInfo.vue?vue&type=script&lang=js"

import "./TransactionInfo.vue?vue&type=style&index=0&id=8fa6b6e0&scoped=true&lang=css"

import exportComponent from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fa6b6e0"]])

export default __exports__